import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  incident: {
    created_at: number;
    resolved_at: number;
    id: number;
    related_id: number;
    group: string;
    message: string;
    related_type: string;
    resolution_message: string;
    severity: string;
    status: string;
    user: {
      id: number;
      first_name: string;
      last_name: string;
    };
  };
}
